export * from "./sidebar.component";
export * from "./sidebar.module";


// WEBPACK FOOTER //
// ./src/app/sidebar/index.ts